import { AxiosError } from "axios";
import { ScheduleLifecyclePeriodLockedError } from "@common/schemas/domains/accounting/scheduleLifecycle.schema";
import { ScheduleLinkedSourceConflictErrorBody } from "@common/schemas/domains/accounting/scheduleLinkedSource.schema";
import {
    ScheduleMilestoneAlreadyPostedError,
    scheduleMilestoneAlreadyPostedErrorSchema,
} from "@common/schemas/domains/accounting/scheduleMilestone.schema";
import { parseScheduleConflictBody } from "@helpers/lock";

export class SchedulePeriodLockedError extends Error {
    constructor(readonly details: ScheduleLifecyclePeriodLockedError) {
        super(details.message);
        this.name = "SchedulePeriodLockedError";
    }
}

export class ScheduleLinkedSourceConflictError extends Error {
    constructor(readonly details: ScheduleLinkedSourceConflictErrorBody) {
        super(details.message);
        this.name = "ScheduleLinkedSourceConflictError";
    }
}

export class ScheduleMilestoneAlreadyRecognizedError extends Error {
    constructor(readonly details: ScheduleMilestoneAlreadyPostedError) {
        super(details.message);
        this.name = "ScheduleMilestoneAlreadyRecognizedError";
    }
}

export class ScheduleMilestoneRefusedError extends Error {
    constructor(message: string) {
        super(message);
        this.name = "ScheduleMilestoneRefusedError";
    }
}

export function getScheduleMilestoneAlreadyPostedError(
    error: AxiosError,
): ScheduleMilestoneAlreadyPostedError | null {
    return parseScheduleConflictBody(
        error,
        scheduleMilestoneAlreadyPostedErrorSchema,
    );
}
